// ⚙️ Datos editables de la landing QLK Fest 2026 (2da edición).
// Cambiar acá links, fecha y textos sin tocar los componentes.

// Fecha de inicio del evento (hora Argentina). Usada por el contador "FALTAN".
export const EVENT_DATE = new Date("2026-12-06T20:00:00-03:00");

// Secciones ocultas por ahora (poner en true para mostrar botón de menú + sección)
export const SHOW_SECTORES = true;
export const SHOW_PERMISO = false;
// Botón LINE UP del menú: en false se ve pero no lleva a ningún lado (la página del Line Up se muestra igual)
export const SHOW_LINEUP = true;
// Página del Line Up (collage Q'Lokura): en false no se muestra
export const SHOW_LINEUP_PAGE = true;
// Puntos de venta: en false se oculta la sección
export const SHOW_PUNTOS = true;
// Menú: en true se muestra el botón COMPRA ONLINE (abre la venta online).
// PUNTOS DE VENTA aparece en el menú cuando SHOW_PUNTOS está en true.
export const MENU_ONLINE = true;

// Venta online (botón ONLINE de Puntos de venta).
export const BUY_URL = "https://qlkfest.qlokura.tv/";

// Botón COMPRAR de cada entrada (General, VIP, Ultra VIP, Parking), debajo de "Compartilo"
export const ENTRADAS_URL = "https://qlkfest.qlokura.tv/#services";

// Compra de cada abono (botón COMPRAR dentro de cada abono desplegado)
export const ABONO_URLS = {
  general: "https://qlokura.tv/evento/QLK-FEST-ABONO-GENERAL/8325",
  vip: "https://qlokura.tv/evento/QLK-FEST-VIP-ABONO/8326",
  ultra: "https://qlokura.tv/evento/QLK-FEST-ABONO-ULTRA-VIP/8327",
};

// Redes / contacto
export const INSTAGRAM_URL = "https://www.instagram.com/qlkfest/";
export const TIKTOK_URL = "https://www.tiktok.com/@qlkfest";
export const EMAIL = "qlkfest@gmail.com";

// Permiso de menores (reemplazar por el PDF 2026 cuando esté)
export const PERMISO_URL =
  "https://enjoy-producciones.s3.us-east-1.amazonaws.com/pdfs/DDJJ_MENORES.docx.pdf";

// Música: poner el mp3 en /public/audio/qlkfest.mp3
export const AUDIO_SRC = `${process.env.PUBLIC_URL}/audio/qlkfest.mp3`;
export const AUDIO_START_AT_SECONDS = 0;
// Playlist oficial de Spotify (marquesina rosa y popup "Escuchar en Spotify" del botón de música)
export const SPOTIFY_URL = "https://open.spotify.com/playlist/5K93bIKwSLoiSfl0apnDtM";

// Marquesina rosa: temas (cada uno abre Spotify)
export const MARQUEE_SONGS = [
  "Quedate / soy favela / Lo que hay por aquí - en vivo",
];

// Puntos de venta físicos (v3). `id` elige la imagen del local en Sections26.js.
export const PUNTOS_FISICOS = [
  // Se muestran como texto con el estilo del diseño (nombre en rosa, dirección y horario debajo).
  // Río Cuarto
  {
    id: "fridezza-castelli",
    nombre: "Fridezza",
    direccion: "Juan José Castelli 1926 - Río Cuarto",
    horario: "De 14 a 20 Hs.",
    detalle: "Juan José Castelli 1926 - Río Cuarto. De 14 a 20 Hs.",
    maps: "https://www.google.com/maps/search/?api=1&query=Fridezza+Juan+Jos%C3%A9+Castelli+1926+R%C3%ADo+Cuarto+C%C3%B3rdoba",
  },
  {
    id: "fridezza-porreca",
    nombre: "Fridezza",
    direccion: "Fray Quirico Porreca 1014 - Río Cuarto",
    horario: "De 14 a 20 Hs.",
    detalle: "Fray Quirico Porreca 1014 - Río Cuarto. De 14 a 20 Hs.",
    maps: "https://www.google.com/maps/search/?api=1&query=Fridezza+Fray+Quirico+Porreca+1014+R%C3%ADo+Cuarto+C%C3%B3rdoba",
  },
  {
    id: "newen-txt",
    nombre: "Kiosco Newen",
    direccion: "Buenos Aires 55 - Río Cuarto",
    horario: "Lunes a sábados: 07:30 a 21 Hs.",
    detalle: "Buenos Aires 55 - Río Cuarto. Lunes a sábados: 07:30 a 21 Hs.",
    maps: "https://maps.app.goo.gl/DzDxU5UX7XzBFccd8",
  },
  // General Deheza
  {
    id: "arlequin-txt",
    nombre: "Kiosco Arlequín",
    direccion: "Bv. San Martín - General Deheza",
    horario: "Lunes a domingo: 24 Hs.",
    detalle: "Bv. San Martín - General Deheza. Lunes a domingo: 24 Hs.",
    maps: "https://www.google.com/maps/search/?api=1&query=Kiosco+Arlequin+Bv.+San+Mart%C3%ADn+General+Deheza+C%C3%B3rdoba",
  },
  // General Cabrera
  {
    id: "lospepos-txt",
    nombre: "Maxikiosco Los Pepos",
    direccion: "Bv. Buenos Aires esq. 9 de Julio - General Cabrera",
    detalle: "Bv. Buenos Aires esq. 9 de Julio - General Cabrera.",
    maps: "https://maps.app.goo.gl/LndE7keTBDKbj3wy6",
  },
];
